'use client';
import React from 'react';

const clients = [
{ name: 'Santander', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a303a9c997917f7cc7f53f5_Santander%201%20(1).svg' },
{ name: 'Bancolombia', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a23162422dd5b4dd53b4719_logo-bancolombia.svg' },
{ name: 'Mercado Libre', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a2316fd831951b7b93c699b_logo-mercadolibre.svg' },
{ name: 'Globant', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a23171b45419fd079cd96cf_logo-globant.svg' },
{ name: 'Telefónica', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a231751d405fc09f9c3d232_logo-telefonica.svg' },
{ name: 'Nubank', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a983e1a63455cec61dc4f3d_Nubank%20Logo%20(2).svg' },
{ name: 'PedidosYa', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a2317383feb5a11a1b0befd_logo-pedidosya.svg' },
{ name: 'Credicorp', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a231655b3f68e0c2a331bfe_logo-credicorp.svg' },
{ name: 'Uala', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a2316cb6fb96d2b8b89860e_logo-uala.svg' },
{ name: 'Yape', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a2316e303770aeb1c9bc1bb_logo-yape.svg' },
{ name: 'Bancoestado', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a23166f667d9a774e9b54ab_logo-bancoestado.svg' },
{ name: 'NaranjaX', logo: 'https://cdn.prod.website-files.com/68ae429f9c9c01aa410a595a/6a2316adb3f68e0c2a33363f_logo-naranjax.svg' }];


export default function TrustedBy() {
  const doubled = [...clients, ...clients];

  return (
    <section className="bg-[#050a0f] border-t border-[#222] py-14 relative overflow-hidden">
      {/* Subtle orb behind logos */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="orb orb-cyan" style={{ width: '600px', height: '200px', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', opacity: 0.15 }} />
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 lg:px-12 mb-10">
        <h2 className="fade-in-up font-heading text-[clamp(1.5rem,3vw,2.5rem)] text-[#f5f5f8] font-medium">
          Trusted by
        </h2>
      </div>

      {/* Marquee */}
      <div className="marquee-container relative">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#050a0f] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#050a0f] to-transparent z-10 pointer-events-none" />

        <div className="marquee-track">
          {doubled?.map((client, i) =>
          <div
            key={i}
            className="flex-shrink-0 flex items-center justify-center px-10 py-4 opacity-40 hover:opacity-90 transition-all duration-500 hover:scale-110">
            
              <img
              src={client?.logo}
              alt={client?.name}
              className="h-6 w-auto object-contain filter brightness-0 invert" />
            
            </div>
          )}
        </div>
      </div>
    </section>);

}